import { Outlet } from 'react-router-dom';
import { NeonErrorPageContent } from '@ps-refarch-ux/neon';
import {
  canRecommendStudentsForCoursesFromCpContext,
  isEmbeddedInSucceed,
  isConsolidatedPermissionsEnabled,
} from '@/utils/cp-context';

/**
 * Blocks Recommendations without a full-page redirect. `CpAccessDeniedRedirect` (used by other CP
 * gates) navigates to Succeed's `/accessdenied.php`, which forwards to `/auth/accessdenied` — the
 * same endpoint wired as the IAM SSO staff error page — and can tear down the session, appearing as
 * a logout. Rendering in place keeps the permission enforced without leaving the SPA.
 */
export function RecommendationsGate() {
  if (
    !isEmbeddedInSucceed() &&
    isConsolidatedPermissionsEnabled() &&
    !canRecommendStudentsForCoursesFromCpContext()
  ) {
    return (
      <NeonErrorPageContent
        dataErrorCode="403"
        dataHeading="You don't have access to this page"
        dataSubheading="Contact your administrator if you believe this is a mistake."
        dataShowErrorCode={true}
      />
    );
  }

  return <Outlet />;
}
